export const images = {
  smapiotWhite: require('../images/smapiot_white.svg'),
  smapiotGreen: require('../images/smapiot_green.svg'),
};
